import React from 'react';
import { components } from 'react-select';
import './CustomMenuList.css';

const CustomMenuList = (props) => {
    const { selectProps, getValue, children } = props;
    const staticOption = selectProps?.staticOption;
    const setMenuIsOpen = selectProps?.setMenuIsOpen;
    const clearInputValue = selectProps?.clearInputValue;

    const selectedValue = getValue();
    const isStaticSelected = selectedValue.some(opt => opt.value === staticOption?.value);

    return (
        <components.MenuList {...props} className="custom-menu-list-wrapper">
            {/* Company Names */}
            {children}

            {/* Unknown / Not Listed Option */}
            {staticOption && (
                <div
                    className={`custom-select-footer ${isStaticSelected ? 'selected' : ''}`}
                    onClick={(e) => {
                        e.stopPropagation();
                        selectProps.onChange(staticOption, {
                            action: 'select-option',
                            option: staticOption,
                        });

                        if (typeof(clearInputValue) === 'function') {
                            clearInputValue();
                        }

                        if (typeof(setMenuIsOpen) === 'function') {
                            setMenuIsOpen(false);
                        }
                    }}
                >
                    {staticOption.label}
                </div>
            )}
        </components.MenuList>
    );
};

export default CustomMenuList;
